import React from 'react'

function Team() {
    return (
        <div>
            {/* Hero Start */}
            <div className="container-fluid pt-5 bg-primary hero-header">
                <div className="container pt-5">
                    <div className="row g-5 pt-5">
                        <div className="col-lg-6 align-self-center text-center text-lg-start mb-lg-5">
                            <h1 className="display-4 text-white mb-4 animated slideInRight">Our Team</h1>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb justify-content-center justify-content-lg-start mb-0">
                                    <li className="breadcrumb-item"><a className="text-white" href="#">Home</a></li>
                                    <li className="breadcrumb-item text-white active" aria-current="page">Our Team</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="col-lg-6 align-self-end text-center text-lg-end">
                            <img className="img-fluid" src="assets/img/hero-img.png" alt style={{ maxHeight: 300 }} />
                        </div>
                    </div>
                </div>
            </div>
            {/* Hero End */}
            {/* Full Screen Search Start */}
            <div className="modal fade" id="searchModal" tabIndex={-1}>
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content" style={{ background: 'rgba(20, 24, 62, 0.7)' }}>
                        <div className="modal-header border-0">
                            <button type="button" className="btn btn-square bg-white btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body d-flex align-items-center justify-content-center">
                            <div className="input-group" style={{ maxWidth: 600 }}>
                                <input type="text" className="form-control bg-transparent border-light p-3" placeholder="Type search keyword" />
                                <button className="btn btn-light px-4"><i className="bi bi-search" /></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
             {/* Team Start */}
            <div className="container-fluid bg-light py-5">
                <div className="container py-5">
                    <div className="row g-5 align-items-center">
                        <div className="col-lg-5 wow fadeIn" data-wow-delay="0.1s">
                            <div className="btn btn-sm border rounded-pill text-primary px-3 mb-3">Our Team</div>
                            <h1 className="mb-4">Meet Our Skilled & Passionate Team</h1>
                            <p className="mb-4">
                                At Bluevipers Technology, our success is fueled by a dynamic team of tech innovators,
                                problem-solvers, and creators committed to delivering excellence. Each member brings deep
                                experience, creativity, and a passion for building future-ready digital solutions.
                            </p>
                            <a className="btn btn-primary rounded-pill px-4" href="#">Learn More</a>
                        </div>

                        <div className="col-lg-7">
                            <div className="row g-4">

                                <div className="col-md-6">
                                    <div className="row g-4">
                                        <div className="col-12 wow fadeIn" data-wow-delay="0.1s">
                                            <div className="team-item bg-white text-center rounded p-4 pt-0">
                                                <img className="img-fluid rounded-circle p-4" src="team1.png" alt />
                                                <h5 className="mb-0">Mr. Rohan Thorat</h5>
                                                <small>Founder </small>
                                            </div>
                                        </div>

                                        <div className="col-12 wow fadeIn" data-wow-delay="0.5s">
                                            <div className="team-item bg-white text-center rounded p-4 pt-0">
                                                <img className="img-fluid rounded-circle p-4" src="team2.png" alt />
                                                <h5 className="mb-0">Mr. Sanjay Waghmare</h5>
                                                <small>Sales Executive</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6 pt-md-4">
                                    <div className="row g-4">
                                        <div className="col-12 wow fadeIn" data-wow-delay="0.3s">
                                            <div className="team-item bg-white text-center rounded p-4 pt-0">
                                                <img className="img-fluid rounded-circle p-4" src="team3.png" alt />
                                                <h5 className="mb-0">Mr. Nilesh Sonwane</h5>
                                                <small>Sales Executive</small>
                                            </div>
                                        </div>

                                        {/* <div className="col-12 wow fadeIn" data-wow-delay="0.7s">
                                            <div className="team-item bg-white text-center rounded p-4 pt-0">
                                                <img className="img-fluid rounded-circle p-4" src="assets/img/team-4.jpg" alt />
                                                <h5 className="mb-0">Priya Shinde</h5>
                                                <small>UX/UI Designer</small>
                                            </div>
                                        </div> */}

                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>


    )
}

export default Team